import Cookies from 'js-cookie';
import { createRestApiClient } from '..';
import { getAddressRequiredParam } from '../../Utils/addressUtils';
import { getUserTokenSSR } from '../../Utils/commonUtils';
import { getCountryCode } from '../../Utils/ForeignUtils';
import { getUserToken } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';
const restApiClient = createRestApiClient();

export const fetchCityAndState = async (pincode) => {
  const url = `api/getNewLocation?random=` + new Date().getTime();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: { pin_code: pincode },
      headers: {
        'authorization': getUserToken(),
        'Mylo-In-App': false,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      fireEvent({
        category: 'api_error',
        error: err?.message,
        req: err?.config?.url,
      });
      let obj = {
        data: {
          success: false,
          pincodeError: 'Pincode is not serviceable',
        },
      };
      return obj;
    });
  return data;
};

export const AddAddress = async (validAddress) => {
  const cart_products = Cookies.get('cart_items') || null;
  let url = `api/address/add?random=` + new Date().getTime();
  const country_code = getCountryCode();
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: {
        ...validAddress,
        product_stage: '',
        product_ids: cart_products,
      },
      headers: {
        'authorization': getUserToken(),
        'Mylo-In-App': false,
        'country_code': country_code,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error;
    });
  return data;
};

export const addressListFetcher = async (param) => {
  const url = `api/address/list?random=` + new Date().getTime();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: param,
      headers: {
        'authorization': getUserToken(),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data);
  return data;
};

export const addressListFetcherSSR = async (cookiesString) => {
  const url = `api/address/list?random=` + new Date().getTime();
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: getAddressRequiredParam(cookiesString),
      headers: {
        'authorization': getUserTokenSSR(cookiesString),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data);
  return data;
};

export const updateUserAddress = async (validAddress) => {
  const url = `api/address/${validAddress.id}?random=` + new Date().getTime();
  const data = await restApiClient
    .request({
      method: 'PUT',
      url: url,
      data: validAddress,
      headers: {
        'authorization': getUserToken(),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data);
  return data;
};

export const updateOrderedAddress = async (order_id, address_id) => {
  const params = { order_id, address_id };
  const url = `api/updateOrderAddress`;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        'authorization': getUserToken(),
        'Mylo-In-App': false,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireEvent({
        category: 'api_error',
        error: err?.message,
        req: err?.config?.url,
      });
    });

  return data;
};
